import { FormPath } from '@formily/react';
import { genOnFieldValueChange } from './onFieldValueChange';
import { generatorLatest } from './utils/generatorLatest';
export const genOnArrayFieldsChange = ($, form) => {
  const onArrayFieldsChange = (pre, keys, cb) => {
    const onFieldValueChange = genOnFieldValueChange($, form);
    const generatorCb = generatorLatest(cb);
    onFieldValueChange(`${pre}.*.*(${keys.join(',')})`, fieldState => {
      const name = fieldState.name;
      const index = parseInt(name.slice(pre.length + 1, -keys.length - 1), 10);
      const fieldStates = keys.map(key => form.getFieldState(`${pre}.${index}.${key}`));
      const fieldValues = fieldStates.map(v => v === null || v === void 0 ? void 0 : v.value);

      const setArrayFieldState = (key, ...arr) => {
        form.setFieldState(FormPath.parse(`${pre}.${index}`).concat(key), ...arr);
      };

      generatorCb({
        fieldStates,
        fieldValues,
        triggerFieldState: fieldState,
        index,
        setArrayFieldState
      });
    });
  };

  return onArrayFieldsChange;
};
//# sourceMappingURL=es/Form/extendsEffects/onArrayFieldsChange.js.map